export const store_rates = JSON.parse(localStorage.getItem("store_rates"))
export const domestic_shipping = 0;
export const local_delivery = 60
export const global_shipping_instruction = `যেহেতু শিপিং চার্জ পণ্যের ওজনের উপর নির্ভরশীল তাই, প্রোডাক্ট
                দেশে আসার পর ওজন করে (প্যাকেট সহ) ওজন অনুসারে প্রতি কেজিতে গুন
                করে শিপিং চার্জ যুক্ত হবে | এছাড়া টোটাল প্রাইসে দেশের ভিতরে
                ডেলিভারি চার্জও যুক্ত থাকেনা, এটি ডেলিভারি সময় পেমেন্ট করতে হবে
                ।`